export const skins = { dark: 'dark', light: 'light', neutral: 'neutral' };
//# sourceMappingURL=constants.js.map